<template>
  <div ref="dropdownContainer" class="combo-dropdown-panel" :style="dropdownStyles">
    <div
      v-if="!loading"
      ref="menuBodyCon"
      class="dropdown-body-container scroller-overlay"
      :style="dropdownBodyStyle"
      @scroll.stop="onDropdownMenuScroll"
    >
      <!-- Phần header của menu khi có grid-->
      <table v-if="columnx && columnx.length > 0" class="dropdown-table" :style="headerStyle">
        <thead v-if="hasHeaderDropdown && columnx.filter(x => x.title != '').length != 0" class="dropdown-header">
          <tr>
            <th v-if="isCheckMultiple" style="width: 60px" class="dropdown-header__th" />
            <th
              v-for="(column, index) in columnx"
              :key="index"
              class="dropdown-header__th"
              :title="column.tooltip"
              :style="getThStyle(column)"
            >
              <!-- Add by ĐVThi fix lỗi căn trái không thẳng hàng tiêu đề cột với dữ liệu phía dưới -->
              <span>{{ column.title }}</span>
              <div
                class="line-resize"
                :style="dropdownHeight"
                @mouseup="resizeOff"
                @mousedown="resizeOn($event, column)"
              ></div>
            </th>
            <slot name="quickSearch"></slot>
          </tr>
        </thead>
        <tbody class="dropdown-items">
          <slot />
        </tbody>
      </table>
      <ul v-else-if="comboType === 1" class="dropdown-items">
        <slot />
      </ul>
      <div
        v-if="!columnx || columnx.length === 0"
        class="line-resize"
        :style="dropdownHeight"
        @mouseup="resizeOff"
        @mousedown="resizeOn($event)"
      ></div>
      <!-- Phần nội dung grid combo có columns và combo tree -->
    </div>

    <!-- Hiển thị loading khi chưa có dữ liệu -->
    <div v-if="loading" class="dropdown--loading" :style="loadingStyles">
      <!-- <div class="ldio-z76ep1av69">
        <div></div>
        <div></div>
        <div></div>
      </div> -->
      <div class="loading-svg">
        <div class="effect-1 effects" />
      </div>
    </div>
    <!--  -->

    <!-- Show thông báo khi không có dữ liệu hiển thị -->
    <div v-else-if="showEmptyText" class="no-data-display" @click="addNewClick">
      <div class="no-data-display__text">
        {{ $t('i18nComponent.Combobox.EmptyText') }}
      </div>
    </div>
    <!--  -->
    <!-- <div class="" v-if="(quickAdd || quickSearch) && isGridEditor">
      <div v-if="quickAdd">Thêm nhanh</div>
      <div v-if="quickSearch">Search nhanh</div>
    </div> -->
    <div class="dropdown-footer-ctn d-flex" v-if="(quickAddInDropdown || quickAddMulti) && isGridEditor">
      <div class="quick-add-dropdown" @click.prevent="addNewClick">
        <div class="btn-quick-add-dropdown"></div>
        <div class="label-quick-add-dropdown">Thêm mới</div>
      </div>

      <slot v-if="quickAddMulti" name="quickAddMulti"></slot>
    </div>
    <div class="dropdown-footer-ctn d-flex" v-if="quickSearchInDropdown">
      <div class="quick-search-dropdown ml-1" @click.prevent="showFormSearch">
        <div class="icon icon24 search-view"></div>
        <div class="label-quick-search-dropdown">Tìm kiếm mở rộng</div>
      </div>

      <slot v-if="quickAddMulti" name="quickAddMulti"></slot>
    </div>
  </div>
</template>

<script>
import {defineComponent, computed, getCurrentInstance, nextTick, onBeforeUnmount, onMounted, ref} from 'vue';
import {useResizeColumnCombobox} from '@/setup/utilities/resizeColumnCombobox';
export default defineComponent({
  name: 'MsComboBoxDropdown',
  props: {
    /**
     * Loại combo sử dụng để style cột
     */
    comboType: {
      type: Number,
      default: 1,
    },
    /**
     * Số lượng item hiển thị ở dropdown
     */
    maxItemsDisplay: {
      type: Number,
      default: 5,
    },

    /**
     * Các cột của dropdown
     */
    columnx: {
      type: Array,
      default() {
        return [];
      },
    },

    /**
     * Trạng thái `loading`
     */
    loading: {
      type: Boolean,
      default: false,
    },
    /**
     * Độ rộng phần dropdown, nếu bằng <=0 hoặc Auto sẽ tự động tính toán
     * CreatedBy PDKIEN 09/12/2019
     */
    dropdownWidth: {
      type: [Number, String],
      default: 0,
    },
    /**
     * Có hiển thị empty text không
     */
    showEmptyText: {
      type: Boolean,
      default: false,
    },
    topx: {
      type: Number,
      default: null,
    },
    bottomx: {
      type: Number,
      default: null,
    },
    leftx: {
      type: Number,
      default: null,
    },
    maxWidthx: {
      type: Number,
      default: null,
    },
    minWidthx: {
      type: Number,
      default: null,
    },
    rowCount: {
      type: Number,
      default: null,
    },
    /**
     * vị trí bản ghi được chọn trước đó
     */
    highlighIndex: {
      type: Number,
      default: null,
    },
    /**
     * vị trí scroll cũ
     */
    scrollTop: {
      type: Number,
      default: 0,
    },
    quickAdd: {
      type: String,
      default: '',
    },
    quickAddInDropdown: {
      type: String,
      default: '',
    },
    /**
     * Tìm kiếm ở dưới dropdown
     * ntduong2 5.3.2024
     */
    quickSearchInDropdown: {
      type: String,
      default: null,
    },
    /**
     * Cấu hình add multi form
     */
    quickAddMulti: {
      type: Array,
      default: null,
    },
    quickSearch: {
      type: String,
      default: '',
    },
    isGridEditor: {
      type: Boolean,
      default: false,
    },
    isCheckMultiple: {
      type: Boolean,
      default: false,
    },
    hasHeaderDropdown: {
      type: Boolean,
      default: true,
    },
    logoField: {
      type: String,
      default: 'logo_url',
    },
    items: {
      type: Array,
      default: () => [],
    },
    displayField: {
      type: String,
      default: 'label',
    },
  },
  setup(props, {emit}) {
    // Variable
    const {resizeOn, resizeOff} = useResizeColumnCombobox(emit);
    let containerWidth = 0;
    const {proxy} = getCurrentInstance();
    const menuBodyCon = ref();
    const dropdownContainer = ref();

    // Method
    /**
     * Hàm lấy style cho th trong table
     * dữ liệu động theo config của dev
     */
    const getThStyle = column => {
      return {
        width: column.isResize ? null : `${column.width}px`,
        textAlign: column.columnAlign,
        minWidth: `${column.minWidth}px`,
      };
    };

    /**
     * Xử lý sự kiện click bất kỳ đâu trên document
     */
    const onDocumentClick = event => {
      const targetCombo = event.target.closest('.ms-combo');
      const comboEl = proxy.$parent.$el;

      if (targetCombo !== comboEl) {
        proxy.$parent.collapse();
      }
    };

    /**
     * Sự kiện khi scroll dropdown menu
     */
    const onDropdownMenuScroll = e => {
      const target = e.target;
      // kiểm tra nếu scroll to bottom -> emit để combobox load thêm dữ liệu
      // làm tròn phần nguyên target.scrollTop do 1 số trường hợp scale to/nhỏ không lấy chẵn được target.scrollTop dẫn tới ko nhảy vào dù đã end scroll
      if (Math.ceil(target.scrollTop) >= target.scrollHeight - target.offsetHeight) {
        emit('scrollend');
      }

      proxy._scrollTop = target.scrollTop;
    };

    /**
     * Xử lý sự kiện scroll document
     * - Đóng menu
     */
    const onDocumentScroll = event => {
      const comboMenu = event.target.closest('.combo-dropdown-panel');
      if (!comboMenu || comboMenu !== proxy.$el) {
        // thêm kiểm tra để sửa lỗi khi combobox.innerText dài quá sẽ không expand dc
        if (event.target && proxy.$parent && proxy.$parent.$refs.input && event.target === proxy.$parent.$refs.input) {
          return;
        }

        proxy.$parent.collapse();
      }
    };

    /**
     *
     * Modified: NXCHIEN 11.11.2022: Check null trước khi call function
     */
    const onWindowResize = () => {
      if (proxy.$parent && typeof proxy.$parent.collapse == 'function') {
        proxy.$parent.collapse();
      }
    };

    /**
     * Hàm append dropdown menu vào thẻ body
     * append vào trước phần tử đầu tiên trong thẻ body
     */
    const insertBody = () => {
      document.body.insertBefore(proxy.$el, document.body.firstChild);
    };

    /**
     * Thêm mới
     */
    const addNewClick = () => {
      emit('addNew');
    };
    /**
     * Mở form tìm kiếm
     */
    const showFormSearch = event => {
      emit('quickSearch', event);
    };
    // Hooks
    const headerStyle = computed(() => {
      return {
        // width: this.headerWidth + "px"
      };
    });

    const headerWidth = computed(() => {
      let width = 0;
      if (containerWidth) {
        width = containerWidth;
      } else if (props.columnx && props.columnx.length > 0) {
        for (let index = 0; index < props.columnx.length; index++) {
          const element = props.columnx[index];
          if (element.width) {
            width = width + element.width;
          }
        }
      }
      return width;
    });

    const dropdownStyles = computed(() => {
      const width = headerWidth;
      const docWidth = document.body.clientWidth;
      let left = props.leftx;
      if (left + width.value + props.dropdownWidth > docWidth) {
        left = left - (width.value + left + props.dropdownWidth - docWidth);
      }
      const res = {
        // top: props.topx + 'px',
        // left: left + "px",
        minWidth: props.minWidthx + 'px',
        maxWidth: props.maxWidthx + 'px',
      };
      if (props.columnx && props.columnx.length > 0) {
        delete res.maxWidth;
        delete res.minWidth;
      }

      props.bottomx ? (res.bottom = props.bottomx + 'px') : (res.top = props.topx + 'px');

      if (left + width.value >= docWidth) {
        res.right = '10px';
      } else {
        res.left = left + 'px';
      }

      return res;
    });

    /**
     * Style dành cho phần mask loading
     */
    const loadingStyles = computed(() => {
      const res = {
        minWidth: props.minWidthx + 'px',
      };

      return res;
    });

    /**
     * Set lại chiều cao tối đa của dropdown nếu số lượng item hiển thị khác default
     */
    const dropdownBodyStyle = computed(() => {
      let style = {};
      if (props.maxItemsDisplay !== 5) {
        style = {
          maxHeight: `${props.maxItemsDisplay * 36}px`,
        };
      }
      // if (props.columnx && props.columnx.length > 0) {
      //   style = {
      //     marginTop: 8 + 'px',
      //     marginRight: 0 + 'px',
      //     marginLeft: 8 + 'px',
      //     marginBottom: 4 + 'px',
      //     borderRadius: 4 + 'px',
      //   };
      // }

      return style;
    });

    /**
     * Set lại chiều cao của line-resize theo height của dropdown
     */
    const dropdownHeight = computed(() => {
      let style = {},
        heightCtn = 0,
        rightCtn = 0;

      if (proxy.rowCount > 0) {
        // height của dropdown (gồm header và rowCount dòng)
        heightCtn = (proxy.rowCount + 1) * 28;

        // max-height của dropdown-body-container
        if (heightCtn > 198) {
          heightCtn = 198; // Lớn hơn max-height thì set = max-height
          rightCtn = 10; // Lớn hơn maxheight thì có hiển thị scrollbar => padding 10px
        }

        style = {
          height: `${heightCtn}px`,
          right: `${rightCtn}px`,
        };
      }

      return style;
    });

    onMounted(() => {
      // Append menu vào thẻ body
      insertBody();
      // Thêm event click vào document
      // document.addEventListener('click', me.onDocumentClick);

      document.addEventListener('scroll', onDocumentScroll);

      window.addEventListener('resize', onWindowResize);

      // highlight
      if (props.scrollTop > 0 && menuBodyCon.value) {
        menuBodyCon.value.scrollTop = props.scrollTop;
      } else if (props.highlighIndex > -1) {
        const row = proxy.$el.querySelector('tr.combobox-item');
        if (row) {
          const rowHeight = row.getBoundingClientRect().height;
          const top = props.highlighIndex * Number.parseInt(rowHeight);
          menuBodyCon.value.scrollTop = top;
        }
      }

      nextTick(() => {
        if (dropdownContainer.value) {
          containerWidth = dropdownContainer.value.clientWidth;
        }
      });
    });

    onBeforeUnmount(() => {
      document.removeEventListener('scroll', onDocumentScroll, true);

      window.removeEventListener('resize', onWindowResize);

      emit('update:scrollTop', proxy._scrollTop);
    });

    return {
      menuBodyCon,
      dropdownContainer,
      headerStyle,
      headerWidth,
      dropdownStyles,
      dropdownBodyStyle,
      dropdownHeight,
      loadingStyles,
      addNewClick,
      showFormSearch,
      getThStyle,
      onDocumentClick,
      onDropdownMenuScroll,
      resizeOn,
      resizeOff,
    };
  },
});
</script>

<style lang="scss" scoped>
@import '@/assets/scss/components/MsComboboxDropdown.scss';
.dropdown-item-logo {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 12px;
  vertical-align: middle;
}
.dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
}
</style>
